var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9987 0.667969C1.52594 0.667969 0.332031 1.86188 0.332031 3.33464V8.66797C0.332031 10.1407 1.52594 11.3346 2.9987 11.3346H10.9987C12.4715 11.3346 13.6654 10.1407 13.6654 8.66797V3.33464C13.6654 1.86188 12.4715 0.667969 10.9987 0.667969H2.9987ZM6.9987 7.33464C7.73508 7.33464 8.33203 6.73768 8.33203 6.0013C8.33203 5.26492 7.73508 4.66797 6.9987 4.66797C6.26232 4.66797 5.66536 5.26492 5.66536 6.0013C5.66536 6.73768 6.26232 7.33464 6.9987 7.33464ZM3.33203 3.0013C3.33203 3.36949 3.03355 3.66797 2.66536 3.66797C2.29717 3.66797 1.9987 3.36949 1.9987 3.0013C1.9987 2.63311 2.29717 2.33464 2.66536 2.33464C3.03355 2.33464 3.33203 2.63311 3.33203 3.0013ZM11.332 3.66797C11.7002 3.66797 11.9987 3.36949 11.9987 3.0013C11.9987 2.63311 11.7002 2.33464 11.332 2.33464C10.9638 2.33464 10.6654 2.63311 10.6654 3.0013C10.6654 3.36949 10.9638 3.66797 11.332 3.66797ZM3.33203 9.0013C3.33203 9.36949 3.03355 9.66797 2.66536 9.66797C2.29717 9.66797 1.9987 9.36949 1.9987 9.0013C1.9987 8.63311 2.29717 8.33464 2.66536 8.33464C3.03355 8.33464 3.33203 8.63311 3.33203 9.0013ZM11.332 9.66797C11.7002 9.66797 11.9987 9.36949 11.9987 9.0013C11.9987 8.63311 11.7002 8.33464 11.332 8.33464C10.9638 8.33464 10.6654 8.63311 10.6654 9.0013C10.6654 9.36949 10.9638 9.66797 11.332 9.66797Z",
    fill: "#FF4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCard);
export default __webpack_public_path__ + "static/media/red-card.5f7c08ab.svg";
export { ForwardRef as ReactComponent };